import { BLOCK_TYPES } from "../../common";
import { isValidCallbackDragArrangeList } from "../DragArrangeList";

const { COMPARE_DIGITS_BLOCK } = BLOCK_TYPES;

const isValidCallback = (props: any) =>
    isValidCallbackDragArrangeList({
        ...props,
        blockType: COMPARE_DIGITS_BLOCK,
    });

export default isValidCallback;
